export { default as DefaultFilled } from '@/assets/graphics/stars/default/filled.svg';
export { default as DefaultHalfFilled } from '@/assets/graphics/stars/default/half-filled.svg';
export { default as DefaultOutline } from '@/assets/graphics/stars/default/outline.svg';
export { default as GolfFilled } from '@/assets/graphics/stars/golf/filled.svg';
export { default as GolfHalfFilled } from '@/assets/graphics/stars/golf/half-filled.svg';
export { default as GolfOutline } from '@/assets/graphics/stars/golf/outline.svg';
export { default as RejseklubbenFilled } from '@/assets/graphics/stars/rejseklubben/filled.svg';
export { default as RejseklubbenHalfFilled } from '@/assets/graphics/stars/rejseklubben/half-filled.svg';
export { default as RejseklubbenOutline } from '@/assets/graphics/stars/rejseklubben/outline.svg';
export { default as SafariFilled } from '@/assets/graphics/stars/safari/filled.svg';
export { default as SafariHalfFilled } from '@/assets/graphics/stars/safari/half-filled.svg';
export { default as SafariOutline } from '@/assets/graphics/stars/safari/outline.svg';

export type Theme = 'primary' | 'secondary' | 'tertiary';
